import { Divider, Grid, TextField, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import GlobalButton from '../../utility/globalButton/button';
import { flagAddTagDialogObj } from './contactsGlobal';
import Required from '../../utility/required';
import { createCampaignContactTagPayload, tagDataInterface, updateCampaignContactTagPayload } from '../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';
import { useSearchParams } from 'react-router-dom';
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface AddNewTagPopupProps {
    flagAddTagDialogObj: flagAddTagDialogObj, 
    setFlagAddTagDialogObj: React.Dispatch<React.SetStateAction<flagAddTagDialogObj>>,

    setFlagEditContactDialog: React.Dispatch<React.SetStateAction<boolean>>,
    flagEditTag: boolean,
    getListOfCampaignContactTagApiCall: (contact_list_id: number) => Promise<void>
}

const AddNewTagPopup: React.FC<AddNewTagPopupProps> = ({ flagAddTagDialogObj, setFlagAddTagDialogObj, setFlagEditContactDialog, flagEditTag, getListOfCampaignContactTagApiCall }) => {

    const { flagLoading, setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { createCampaignContactTagApi, updateCampaignContactTagApi } = useContext(ContactContext) as ContactContextPayload;
    const { selectedWhatsAppCampaign } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [tagNameValue, setTagNameValue] = useState<string>(flagEditTag ? flagAddTagDialogObj?.selectedTag?.contact_tag_name || "" : "");

    const [searchParams, setSearchParams] = useSearchParams();
    const list_id = searchParams.get('contact_list_id');

    const getContactListId = () => {
        const contactListId = list_id ?? selectedWhatsAppCampaign?.contact_list_id;
        return Number(contactListId);
    }

    const createCampaignContactTagApiCall = async (payload: createCampaignContactTagPayload) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const response = await createCampaignContactTagApi(payload);
        if (response.status) {
            showSuccess(`Tag Created Successfully`)
            
            const contactListId = getContactListId();
            if (contactListId) getListOfCampaignContactTagApiCall(contactListId);
        } else {
            handleError(response);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const updateCampaignContactTagApiCall = async (payload: updateCampaignContactTagPayload) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const response = await updateCampaignContactTagApi(payload);
        if (response.status) {
            showSuccess(`Tag Updated Successfully`)

            const contactListId = getContactListId();
            if (contactListId) getListOfCampaignContactTagApiCall(contactListId);
        } else {
            handleError(response);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const handleCancelClick = () => {
        if(flagAddTagDialogObj.flagFromEditContactDialog){
            setFlagEditContactDialog(true); 
        }  

        setFlagAddTagDialogObj((prev) => ({
            flag: false,
            flagFromEditContactDialog: false,
            selectedTag: prev?.selectedTag
        }))
    }

    const handleAddClick = () => {
        if(flagEditTag){
            const selectedTag = flagAddTagDialogObj?.selectedTag; 
            if(selectedTag){
                const payload: updateCampaignContactTagPayload = {
                    contact_tag_id: selectedTag?.contact_tag_id,
                    contact_tag_name: tagNameValue
                }
                updateCampaignContactTagApiCall(payload);
            }
        } else {
            const payload = {
                contact_list_id: getContactListId(),
                contact_tag_data: [
                    {
                        contact_tag_name: tagNameValue,
                    }
                ]
            }
            createCampaignContactTagApiCall(payload);
        }
        handleCancelClick();
    }

    const checkDisabledAddBtn = () => {
        if(tagNameValue.trim().length === 0){
            return true;
        }

        if(flagEditTag){
            if(tagNameValue == (flagAddTagDialogObj?.selectedTag?.contact_tag_name || "")){
                return true;
            }
        }
        return false;
    }

    const getPopupTitle = () => {
        let title = 'Add New Tag';
        if(flagEditTag){
            title = `Edit Tag - ${flagAddTagDialogObj?.selectedTag?.contact_tag_name}`;
        }
        return title;
    }

    return (
        <>
            <Grid container>
                <Grid xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={style.popupTitleTypography}>
                                {getPopupTitle()}
                            </Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />

                        <Grid item>
                            <Grid container className={style.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Tag Name <Required /></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                value={tagNameValue}
                                                onChange={(e) => { setTagNameValue(e.target.value) }}
                                                className={`${style.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                                                placeholder='Enter New Tag'
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} sx={{ padding: "20px 0" }}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Cancel"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='borderedButtonStyle'
                                        onClick={() => { handleCancelClick() }}
                                    >
                                    </GlobalButton>
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText={flagEditTag ? 'Edit' : 'Add'}
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='primaryButtonStyle'
                                        disabled={checkDisabledAddBtn()}
                                        onClick={() => { handleAddClick() }}
                                    >
                                    </GlobalButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AddNewTagPopup
